import React from 'react';
import { Divisor } from 'components';
import { CSSObject } from 'styled-components';
import { SectionContentStyled } from './layout.styled';

interface SectionContentProps {
  sx?: CSSObject;
  isDivisorVisible?: boolean;
  children?: React.ReactNode | React.ReactNode[];
}

export const SectionContent = ({
  children,
  isDivisorVisible,
  ...rest
}: SectionContentProps) => {
  return (
    <>
      <SectionContentStyled {...rest}>{children}</SectionContentStyled>
      {isDivisorVisible ? <Divisor /> : null}
    </>
  );
};
